import type { CSSProperties } from 'react';

export type RobotMood = 'happy' | 'curious' | 'laughing' | 'sleepy' | 'grumpy' | 'neutral';

type RobotAvatarProps = {
  mood?: RobotMood;
  size?: 'small' | 'medium' | 'large';
  speaking?: boolean;
};

const moodLabel: Record<RobotMood, string> = {
  happy: 'مبسوط',
  curious: 'مستغرب',
  laughing: 'يضحك',
  sleepy: 'نعسان',
  grumpy: 'زعلان بشكل فكاهي',
  neutral: 'رايق',
};

export function RobotAvatar({ mood = 'happy', size = 'large', speaking = false }: RobotAvatarProps) {
  const style = { '--robot-size': size === 'large' ? 'clamp(220px, 48vw, 330px)' : size === 'medium' ? '116px' : '62px' } as CSSProperties;
  return (
    <div className={`robot-avatar robot-${size} robot-${mood} ${speaking ? 'robot-speaking' : ''}`} style={style} role="img" aria-label={`أبو عبيد، تعبير ${moodLabel[mood]}`}>
      <div className="robot-aura" />
      <img className="robot-photo" src="/abu-obaid.png" alt="" aria-hidden="true" />
      <span className="robot-mood-chip">{moodLabel[mood]}</span>
    </div>
  );
}
